module.exports = __webpack_public_path__ + "img/USER_TOTAL.5a5a2a5d.svg";